import { DocStoreContext } from 'stores/DocStore'
import { useDocStoreSync } from 'screens/ArticleViewWrapper/useDocStoreSync'
import { ProsePreview } from 'common/ProsePreview/ProsePreview'
import { AlmanacFileUnion } from './Types'
import { schema } from 'prose-core'
import { prepareNodes } from 'proseShared/utils/general'

export const ArticlePostPreview = ({ almanacFile }: { almanacFile: AlmanacFileUnion }) => {
  const docStore = useDocStoreSync(almanacFile.key)

  if (!docStore || !almanacFile.elements) return null

  return (
    <DocStoreContext.Provider value={docStore}>
      <ProsePreview schema={schema} nodes={prepareNodes(almanacFile.elements, schema)} />
    </DocStoreContext.Provider>
  )
}
